import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import api from '../../api/api';
import MuiDialogWrapper from '../../components/MuiDialogWrapper/MuiDialogWrapper';
import { i18n } from '../../i18n/i18n';

interface NoWorkspacesDialogProps {
    close: any;
    data: any;
}

const NoWorkspacesDialog: FC<NoWorkspacesDialogProps> = ({ close, data }) => {
    return (
        <MuiDialogWrapper
            styles={{ width: '720px' }}
            title={i18n.translate('No Workspaces Found')}
            content={
                <Box>
                    <Typography>
                        {i18n.translate(
                            'We did not find workspaces assigned to this user account. Please contact your administrator',
                        )}
                    </Typography>
                </Box>
            }
            buttons={[
                {
                    name: 'Logout',
                    onClick: () => {
                        api.authentication.logout();
                    },
                },
            ]}
            showExitButton={false}
        />
    );
};

export default NoWorkspacesDialog;
